const messages = {
		'ar': () => import('./src/translations/questionnaire/ar.json'),
'de-DE': () => import('./src/translations/questionnaire/de-DE.json'),
'el': () => import('./src/translations/questionnaire/el.json'),
'en': () => import('./src/translations/questionnaire/en.json'),
'es-ES': () => import('./src/translations/questionnaire/es-ES.json'),
'et': () => import('./src/translations/questionnaire/et.json'),
'fr': () => import('./src/translations/questionnaire/fr.json'),
'it': () => import('./src/translations/questionnaire/it.json'),
'ja': () => import('./src/translations/questionnaire/ja.json'),
'ko': () => import('./src/translations/questionnaire/ko.json'),
'lt': () => import('./src/translations/questionnaire/lt.json'),
'lv': () => import('./src/translations/questionnaire/lv.json'),
'nl': () => import('./src/translations/questionnaire/nl.json'),
'pl': () => import('./src/translations/questionnaire/pl.json'),
'pt-BR': () => import('./src/translations/questionnaire/pt-BR.json'),
'pt-PT': () => import('./src/translations/questionnaire/pt-PT.json'),
'ru': () => import('./src/translations/questionnaire/ru.json'),
'tr': () => import('./src/translations/questionnaire/tr.json'),
'uk': () => import('./src/translations/questionnaire/uk.json'),
'vi': () => import('./src/translations/questionnaire/vi.json'),
'zh-CN': () => import('./src/translations/questionnaire/zh-CN.json'),
'zh-TW': () => import('./src/translations/questionnaire/zh-TW.json'),
	};

	module.exports = messages;
